/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/31
 * @updateTime 2021/8/31
 * @decription 我的保全申请 =》 对应的按钮动作处理js
 * @namespace 【ba】 button action
 */
import wx from "weixin-js-sdk";
export default {
    // 方法
    methods: {

        /**
         * 详情按钮
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        ba_xq(btnItem, dataItem) {
            this.$router.push({
                path: '/preservationDetail',
                query:{
                    // 保全类型
                    bqlx: dataItem.cBqlx,
                    // 保全类别
                    bqlb: dataItem.cBqlb,
                    // 保全id
                    bqid: dataItem.cId,
                    // 担保情况
                    dbqk: dataItem.cDbqk
                }
            })
        },

        /**
         * 申请复议事件
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        ba_sqfy(btnItem, dataItem) {
            // 请求复议
            this.requestFyfzbqxx({bqid: dataItem.cId}).then(res => {
                this.$router.push({
                    path: '/applyReconsider',
                    query: {
                        // 复议id
                        id: res.data,
                        // 发送保全id
                        bqid: dataItem.cId
                    }
                });
            })
        },

        /**
         * 解除保全
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        // 针对财产保全  show48 false 返回旧的解除 如果是true 就返回新版的解除
        ba_jcbq(btnItem, dataItem) {
            // debugger
            let cBqlx = sessionStorage.getItem('cBqlx');
            let show48 = sessionStorage.getItem('show48');
            if (cBqlx == '1' && !show48) {
                // 跳转到解除保全页面
                this.$router.push({
                    path: '/relievePreservation',
                    query: {
                        // // 保全id
                        bqid: dataItem.cId,
                        // cId: dataItem.cId,
                        // // 申请编号
                        sqbh: dataItem.cSqbh
                    }
                });
            } else {
                // 跳转到解除保全页面
                this.$router.push({
                    path: '/relievePreservationNew',
                    query: {
                        // // 保全id
                        bqid: dataItem.cId,
                        cId: sessionStorage.getItem("cId"),
                        // cId: dataItem.cId,
                        // // 申请编号
                        sqbh: dataItem.cSqbh
                    }
                });
            }

        },

        /**
         * 续行保全
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        // 针对财产保全  show48 false 返回旧的续行 如果是true 就返回新版的续行
        ba_xxbq(btnItem, dataItem) {
            let cBqlx = sessionStorage.getItem('cBqlx');
            let show48 = sessionStorage.getItem('show48');
            if (cBqlx === '1' && !show48) {
                this.$router.push({
                    path: '/continuationPreservation',
                    query: {
                        // 保全id
                        bqid: dataItem.cId,
                        // cId: sessionStorage.getItem("cId"),
                        // cId: dataItem.cId,
                        // 申请编号
                        sqbh: dataItem.cSqbh
                    }
                });
            } else {
                this.$router.push({
                    path: '/continuationPreservationNew',
                    query: {
                        // 保全id
                        bqid: dataItem.cId,
                        cId: sessionStorage.getItem("cId"),
                        // cId: dataItem.cId,
                        // 申请编号
                        sqbh: dataItem.cSqbh
                    }
                });
            }
        },

        /**
         * 补充担保
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        ba_bcdb(btnItem, dataItem) {
            let source = {
                sqrXm: dataItem.cSqrxm
            };
            this.$router.push({
                path: '/previewBCDB',
                query: {
                    // 保全id
                    bqid: dataItem.cId,
                    // 资源
                    source: JSON.stringify(source),
                    // 模式为1 补充担保 2 变更担保
                    mode: '1'
                }
            });
        },

        /**
         * 变更担保
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        ba_bgdb(btnItem, dataItem) {
            let source = {
                sqrXm: dataItem.cSqrxm
            };
            this.$router.push({
                path: '/previewBCDB',
                query: {
                    // 保全id
                    bqid: dataItem.cId,
                    // 资源
                    source: JSON.stringify(source),
                    // 模式为1 补充担保 2 变更担保
                    mode: '2'
                }
            });
        },

        /**
         * 交费
         * @param {Object} btnItem 按钮信息项
         * @param {Object} dataItem 数据信息项
         * @returns {void}
         * */
        ba_jf(btnItem, dataItem) {
            /*this.requestDowsjfbydzfy({
                bqid: dataItem.cId
            }).then(res => {
                if (res.code === 200) {

                } else {
                    this.$notify(res.message);
                }
            })*/
            // 微信跳转到交费页面
            wx.miniProgram.navigateTo({
                url: '/pages/text/text?id=' + dataItem.cId
            });
        }
    }
};
